import ResumeItem from "@/common/components/ResumeItem";
import { useFormContext, useWatch } from "react-hook-form";
import { DirectiveComplexityValidationSchema } from "../../../../schemas/maintenanceForwardingDirectiveSteps.schema";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../../../../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepCompleted from "../../../CreateForwardingDirectiveEntryFormStepCompleted";

const DirectiveComplexityFormStepCompleted = ({
  stepIndex,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity>) => {
  const {
    control,
  } = useFormContext<DirectiveComplexityValidationSchema>();

  const {
    complexity: watchComplexity,
  } = useWatch({
    control,
  });

  return (
    <CreateForwardingDirectiveEntryFormStepCompleted
      stepIndex={stepIndex}
      title="Método de check-in"
      body={(
        <div>
          <ResumeItem
            label="Complexidade do diagnóstico"
            value={(watchComplexity?.label as string | JSX.Element) || '--'}
            className="text-sm"
          />
        </div>
      )}
    />
  )
}

export default DirectiveComplexityFormStepCompleted;
